import { render, staticRenderFns } from "./AttendStaticExam.vue?vue&type=template&id=6a36e62a&scoped=true&"
import script from "./AttendStaticExam.vue?vue&type=script&lang=js&"
export * from "./AttendStaticExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a36e62a",
  null
  
)

export default component.exports